import { Box, CircularProgress, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";

import { AccountSwitcherOptionDesktop } from "./AccountSwitcherOption";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";

interface AccountSwitcherOptionGroupDesktopProps {
  userDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
}

export function AccountSwitcherOptionGroupDesktop(props: AccountSwitcherOptionGroupDesktopProps) {
  const { userDetails, onUserClicked } = props;
  const listCount = userDetails?.list.length || 0;

  if (!userDetails.loading && !listCount) {
    return (
      <Text italic variant="body2" color={(theme) => theme.palette.navbar?.itemContent} padding={2}>
        No Records
      </Text>
    );
  }

  const userList: AccountSwitcherUser[] | undefined = userDetails?.list;

  return (
    <Stack gap={2}>
      {userList.map((user: AccountSwitcherUser) => (
        <AccountSwitcherOptionDesktop
          key={user.userId}
          title={user.title}
          subtitles={user.subtitles}
          stage={user.stage}
          onClick={() => {
            onUserClicked(user);
          }}
        />
      ))}
      {userDetails.loading || userDetails.isFetchingNextPage ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
            gap: 1,
          }}
        >
          <CircularProgress
            size={16}
            sx={(theme) => ({ color: theme.palette.navbar?.itemContent })}
          />
          <Text variant="body2" sx={(theme) => ({ color: theme.palette.navbar?.itemContent })}>
            Loading...
          </Text>
        </Box>
      ) : (
        userDetails.hasNextPage && (
          <Button
            fullWidth
            variant="secondary"
            onClick={async () => await userDetails.fetchNextPage()}
          >
            Load more results
          </Button>
        )
      )}
    </Stack>
  );
}
